// Quickstart (adoption on-ramp) API client + types

export interface QuickstartServer { serverId: string; name: string; endpoint: string }
/** Where to send traffic for the sample agent; combined with the firewall base URL. */
export interface QuickstartGateway { chatCompletionsPath: string; model: string }
export interface QuickstartSummary {
  provisioned: boolean;
  agent: { agentId: string; name: string; status: string } | null;
  mcpServers: QuickstartServer[];
  policy: { name: string; protections: string[] } | null;
  gateway?: QuickstartGateway;
}
export interface QuickstartProvisionResult extends QuickstartSummary {
  token: string;
  tokenExpiresAt: string;
}

async function req<T>(url: string, method: 'GET' | 'POST'): Promise<T> {
  const res = await fetch(url, { method });
  if (!res.ok) {
    const b = await res.json().catch(() => ({}));
    throw new Error(b.message || b.error || `Request failed (${res.status})`);
  }
  return res.json();
}

export function getQuickstartStatus(apiUrl: string): Promise<QuickstartSummary> {
  return req(`${apiUrl}/api/admin/quickstart/status`, 'GET');
}

export function provisionQuickstart(apiUrl: string): Promise<QuickstartProvisionResult> {
  return req(`${apiUrl}/api/admin/quickstart/provision`, 'POST');
}

export function teardownQuickstart(apiUrl: string): Promise<{ ok: boolean }> {
  return req(`${apiUrl}/api/admin/quickstart/teardown`, 'POST');
}
